import { Controller } from "@hotwired/stimulus"
import { createApp } from 'vue/dist/vue.esm-bundler.js'
import SummaryTile from '../../../../frontend/components/SummaryTile.vue'
import PrimeVue from 'primevue/config';

export default class extends Controller {
  connect() {
    console.log('Summary detected.  Mounting.')

    this.app = createApp()
    this.app.component('summarytile', SummaryTile)
    this.app.use(PrimeVue, { unstyled: true })
    this.app.mount('#summary-content > div') // #summary-content container is never replaced, so it can't be mounted repeatedly
  }

  disconnect() {
    this.app.unmount()
  }
}
